var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    id: "comment",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.898 29.382a1 1 0 0 0 .906.576c2.87 0 5.298-.698 8.056-2.324 1.338.212 3.98.474 5.14.474 8.756 0 15.878-5.846 15.878-13.034S24.756 2.042 16 2.042.122 7.886.122 15.074c0 3.388 1.634 6.662 4.51 9.088a17.344 17.344 0 0 1-2.594 4.154c-.248.3-.304.716-.14 1.066zm.224-14.308C2.122 8.99 8.348 4.04 16 4.04s13.878 4.95 13.878 11.034S23.652 26.108 16 26.108c-1.148 0-4.136-.308-5.146-.504a1.035 1.035 0 0 0-.71.128c-1.864 1.14-3.49 1.792-5.23 2.068a19.018 19.018 0 0 0 1.86-3.586.997.997 0 0 0-.328-1.16c-2.79-2.112-4.324-4.948-4.324-7.98z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.6d356df151810484e4579ab789cc968f.svg";
export { ForwardRef as ReactComponent };